import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';

/**
 * Direct selector to the signinPage state domain
 */

const selectSigninPageDomain = (state: ApplicationRootState) => {
  return state ? state.signinPage : initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by SigninPage
 */

const selectSigninPage = () =>
  createSelector(selectSigninPageDomain, substate => {
    return substate;
  });

export default selectSigninPage;
export { selectSigninPageDomain };
